var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "DatePicker",
    class: {
      'DatePicker--withIcon': _vm.icon
    }
  }, [_c('vue-date-picker', {
    attrs: {
      "disabled-date": _vm.getMinMax,
      "format": _vm.getFormat,
      "lang": _vm.lang,
      "type": _vm.type
    },
    model: {
      value: _vm.currentDate,
      callback: function ($$v) {
        _vm.currentDate = $$v;
      },
      expression: "currentDate"
    }
  }), _vm.icon ? _c('span', {
    staticClass: "DatePicker-customIcon",
    class: _vm.icon
  }) : _vm._e(), _c('span', {
    staticClass: "DatePicker-label",
    class: [{
      'DatePicker-label--filled': _vm.dateFilled
    }, {
      'DatePicker-label--withIcon': _vm.icon
    }]
  }, [_vm._v(" " + _vm._s(_vm.label) + " "), _c('span', {
    staticClass: "DatePicker-hint"
  }, [_vm._v(_vm._s(_vm.getHint))]), _vm.isRequired ? _c('span', {
    staticClass: "DatePicker-required"
  }, [_vm._v("*")]) : _vm._e()]), _vm.dateFilled ? _c('button', {
    staticClass: "DatePicker-button",
    attrs: {
      "aria-label": _vm.$t('datePicker.cross.aria-label')
    },
    on: {
      "click": _vm.clearDate
    }
  }, [_c('span', {
    staticClass: "DatePicker-icon common-cross"
  })]) : !_vm.icon && _vm.type !== 'time' ? _c('span', {
    staticClass: "DatePicker-icon DatePicker-button DatePicker-button--withoutEvent common-calendar"
  }) : _vm._e(), _c('div', {
    staticClass: "DatePicker-error",
    class: {
      'DatePicker-error--displayed': _vm.errorLabel !== ''
    },
    attrs: {
      "aria-label": _vm.errorLabel,
      "tabindex": _vm.getErrorTabIndex
    }
  }, [_vm._v(" " + _vm._s(_vm.errorLabel) + " ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }